import React from 'react';
import { Check } from 'lucide-react';
import { Row } from './Collection';
import './Checklist.css';

// A CHECKLIST: one row per step of something set up, each its label, how it
// stands at its end (✓ Done, Missing, Not needed, or a word of its own) and,
// pressed, the door to that step (a plugin's Setup: Account · Credentials ·
// Settings · Approve, each opening the set-up sheet there).
//
//   <Checklist label="Setup" items={[
//       { id: 'account', label: 'Account', status: 'done', sub: 'sk@strava', onOpen },
//       { id: 'settings', label: 'Settings', status: 'missing', sub: 'Username', onOpen },
//   ]} />
//
// `status`: done · missing · not_needed · warn (say it in `word`). `word`
// replaces the status's own word.

const WORD = { done: 'Done', missing: 'Missing', not_needed: 'Not needed', warn: 'Wants a look' };
const TONE = { missing: 'live', warn: 'warn' };

function Mark({ status }) {
    return (
        <span className={`nx-check__mark is-${status}`} aria-hidden="true">
            {status === 'done' && <Check size={11} strokeWidth={2.4} />}
        </span>
    );
}

export function Checklist({ items, label }) {
    const list = (items || []).filter(Boolean);
    if (!list.length) return null;
    return (
        <div className="nx-rows nx-check" role="list" aria-label={label}>
            {list.map((x) => {
                const status = x.status || 'missing';
                const word = x.word || WORD[status] || status;
                return (
                    <div role="listitem" key={x.id || x.label} className={`nx-check__item is-${status}`}>
                        <Row
                            lead={<Mark status={status} />}
                            name={x.label}
                            sub={x.sub}
                            end={status === 'done' ? <>✓ {word}</> : word}
                            endTone={TONE[status]}
                            dim={status === 'not_needed'}
                            onPress={x.onOpen && !x.disabled ? x.onOpen : undefined}
                        />
                    </div>
                );
            })}
        </div>
    );
}

export default Checklist;
